export const jobsQuery = (
  { query }: { query?: Ref<Record<string, any>> } = {
    query: undefined,
  }
) =>
  queryOptions({
    queryKey: ['jobs', query],
    queryFn: async ({ signal }): Promise<Job[]> => {
      const res = await useCustomFetch<{
        data: Job[]
      }>({ url: '/enums/qlis-jobs', query: query?.value, signal, clientOnly: true })
      return res?.data
    },
  })

export const jobsPartsQuery = ({
  jobId,
  enabled,
}: {
  jobId: Ref<string> | string
  enabled?: Ref<boolean> | boolean
}) =>
  queryOptions({
    queryKey: ['jobs', 'parts', jobId],
    queryFn: async ({ signal }): Promise<Job & { parts: JobPart[] }> => {
      const res = await useCustomFetch<{
        data: Job[]
      }>({ url: `/enums/qlis-jobs/${unref(jobId)}`, signal, clientOnly: true })
      return res?.data
    },
    enabled,
  })
